<template>
  <ion-page>
    <master-layout pageTitle="درخواست های فروش">
      <ion-card>
        <ion-card-content>
          <router-link to="/WastageSellRequest/Add">
            <ion-button color="success">
              افزودن درخواست  جدید
            </ion-button>
          </router-link>
          <DataTable :headers="headers" route="WastageSellReq/listAjax"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:[
        'تاریخ ثبت',
        'وضعیت',
        'تعداد آیتم',
        'امکانات'
      ]
    };
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>